export const mapGtmItem = (item) => ({
  item_id: item?.slug,
  item_name: item?.name,
  item_category: 'Apartment Rentals',
});

export const mapGtmReservation = (id, reservation) => ({
  transaction_id: id,
  price: reservation.totalPrice,
  currency: 'SEK',
  item: {
    item_id: reservation?.listing?.slug,
    item_name: reservation?.listing?.name,
    item_category: 'Apartment Rentals',
    price: reservation.totalPrice,
    quantity: 1,
  },
});

export const pushSearchButton = (pageName = 'landing') => {
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'guest_search_click',
      elementName: 'Search button',
      pageName,
    });
};

export const pushListingCard = (pageName = 'landing', item) => {
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'guest_select_listing',
      elementName: 'Listing card',
      pageName,
      ecommerce: { items: [item] },
    });
};

export const pushCheckAvailability = (item) => {
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'guest_check_availability',
      elementName: 'Check availability',
      pageName: 'Availability widget',
      ecommerce: { items: [item] },
    });
};

export const pushBookingCheckoutStart = (item) => {
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'guest_begin_checkout',
      elementName: 'Book now',
      pageName: 'Availability widget',
      ecommerce: { items: [item] },
    });
};

export const pushBookingCheckoutComplete = (reservation = {}) => {
  const { item, ...props } = reservation;
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'guest_purchase',
      elementName: 'Booking confirmation',
      pageName: 'Booking confirmation',
      ecommerce: { ...props, items: [item] },
    });
};

export const pushOwnerGetStarted = (pageName = 'landing') => {
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'owner_get_started_click',
      elementName: 'Owner - get started',
      pageName,
    });
};

export const pushOwnerLeadSubmitted = (pageName = 'landing') => {
  window.dataLayer?.push &&
    window.dataLayer.push({
      event: 'owner_lead_submit_action',
      elementName: 'Owner - lead submitted',
      pageName,
    });
};
